import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable, OnInit } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  map,
  Observable,
  of,
  shareReplay,
  switchMap,
  take,
  tap,
} from 'rxjs';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { BACKEND_URLS, BackendUrls } from 'app/app.config';
import { filter } from 'lodash';

export interface Opzione {
  field?: string;
  value: string | number;
  label: string;
  group?: string;




}

export interface Elenchi {
  [key: string]: Opzione[]
}

export interface Targa {
  tipo?: string;
  marca?: string;
  targa: string;
  euro?: string;
  massa?: number
}


@Injectable({
  providedIn: 'root',
})
export class ElenchiService {
  constructor(
    @Inject(BACKEND_URLS) private backendUrls: BackendUrls,
    private _httpClient: HttpClient,
    private _activatedRoute: ActivatedRoute
  ) { }


  public conteggioTarghe: number = 0;

  //private _elenchi: BehaviorSubject<Opzione[] | null> = new BehaviorSubject([]);

  private _elenchi: Opzione[] = [];

  //Ritorna l'elenco delle opzioni per un tipo campo NUOVA!!!
  getOptionsList(field_type: string): any {
    return this._httpClient
      .get<Opzione[]>(`${this.backendUrls.backendApiUrl}/elenchi`, {
        params: { field_type },
      })
      .pipe(
        shareReplay(1),
        map((result) => result['data']),
        catchError((err: HttpErrorResponse) => {
          if (err.status === 200) {
            return of([]);
          }
          return of([]);
        })
      )
  }


  //Ritorna la label dato il value NUOVA!!!
  getLabelOption(field_type: string, value: string): any {

    return this._httpClient
      .get<Opzione[]>(`${this.backendUrls.backendApiUrl}/elenchi/label`, {
        params: { field_type, value },
      })
      .pipe(
        shareReplay(1),
        map((result) => result["label"]),
        catchError((err: HttpErrorResponse) => {
          if (err.status === 200) {
            return of(value);
          }
          return of(value);
        })
      )
  }

  getLabelsOption(field_type: string, values: string[]): any {
    return this._httpClient
      .get<Opzione[]>(`${this.backendUrls.backendApiUrl}/elenchi/labels`, {
        params: { field_type: field_type, values: values.join(',') },
      }).pipe(
        shareReplay(1),
        catchError((err: HttpErrorResponse) => {
          if (err.status === 200) {
            return of(values);
          }
          return of(values);
        })
      )
  }



  //Ritorna tutti gli elenchi per una form
  getElenchi(form: string): any {
    return this._httpClient
      .get<any>(`${this.backendUrls.backendApiUrl}/elenchi`, {
        params: { form },
      })
      .pipe(
        shareReplay(1),
        map((result) => result['data']),
        tap((elenchi) => this._elenchi = elenchi),
        catchError((err: HttpErrorResponse) => {
          if (err.status === 200) {
            return of(true);
          }
          return of([]);
        })
      )
  }


  getElenco(nonserve = '', field: string): Opzione[] {
    console.log("gggggggggggggggggggggg")
    return this._elenchi.filter((element) => element.field == field);
  }

  getLabel(field: string): string {
    //return 'dddd'
    const row = this._elenchi.filter((element) => element.field == field)
    if (row.length > 0) {
      return row[0].label
    }
    else {
      return ''
    }
  }

  //private elenchi: Elenchi;


  getOptions(field: string, firstEmpty: boolean = true): Opzione[] {
    if (!this.elenchi[field]) {
      return []
    }
    const elenco = [...this.elenchi[field]]
    if (firstEmpty) {
      elenco.unshift({ value: null, label: '' })
    }
    return elenco
  }

  getOptionLabel(field: string, value: string | number) {
    if (!this.elenchi[field]) {
      return ''
    }

    const res = this.elenchi[field].filter((x: any) => x.value == value);
    if (res.length > 0) {
      return res[0].label;
    }
    else {
      return value
    }
  }


  getTarghe(skip: boolean = false): Observable<Targa[]> {

    if (skip) {
      return of([])
    }

    return this._httpClient.get<Targa[]>(`${this.backendUrls.backendApiUrl}/istanzetd/veicoli`, {
    }).pipe(
      map(response => response["data"]),
      tap(data => this.conteggioTarghe = data.length),
      map(data => data.map((v) => <Opzione>{ value: v.targa, label: v.targa })),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 200) {
          console.log(err['message']);
        }
        console.log(err['message']);
        return of([
        ]);
      })
    )

  }



  elenchi: Elenchi = {

    qualita_pug: [
      { value: 1, label: 'Privato Cittadino - non proprietario e non titolare di altri diritti di godimento' },
      { value: 2, label: 'Privato Cittadino -  Proprietario o titolare di altri diritti di godimento' },
      { value: 3, label: 'Tecnico incaricato dalla proprietà' },
      { value: 4, label: "Persona delegata dalla proprietà o dal titolare di altri diritti di godimento" },
      { value: 5, label: "Legale rappresentate dell' Associazione/Ente" },
      { value: 6, label: "Ordine professionale (Presidente)" },
      { value: 7, label: 'Legale rappresentate della società / Ditta' },
      { value: 8, label: 'Amministratore' },
      { value: 9, label: 'Altro' }
    ],

    tipo_stato: [
      { value: "compilazione", label: "In compilazione" },
      { value: "riepilogo", label: "Riepilogo" },
      { value: "presentata", label: "Presentata" },
      { value: "pagamento-presentazione", label: "Attesa pagamento presentazione" },
      { value: "errore-protocollo", label: "Errore di protocollazione" }
    ],

    tipo_ordinamento: [
      { value: "data_aggiornamento", label: "Ultimo aggiornamento" },
      { value: "data_protocollo", label: "Data protocollo" },
      { value: "stato", label: "Stato" }
    ],

    tipo_istanza: [
      { value: "domanda-tesserino", label: "Domanda tesserino hobbisti", group: "attivita-produttive" },
      { value: "rilascio-autorizzazione", label: "Richiesta rilascio autorizzazione", group: "attivita-produttive" },
      { value: "partecipazione-mercati-fiere", label: "Istanza partecipazione a mercati/fiere", group: "attivita-produttive" },
      { value: "subentro-autorizzazione", label: "Comunicazione subentro autorizzazione commercio su aree pubbliche", group: "attivita-produttive" },
      { value: "partecipazione-prodotti-agricoli", label: "Istanza partecipazione al Mercato vendita diretta prodotti agricoli", group: "attivita-produttive" },
      { value: "risoluzione-contratto", label: "Comunicazione risoluzione contratto", group: "attivita-produttive" },
      { value: "cessazione-attivita", label: "Comunicazione cessazione attività", group: "attivita-produttive" },
      { value: "sospensione-attivita", label: "Comunicazione sospensione attività", group: "attivita-produttive" },
      { value: "rilascio-attestazione", label: "Richiesta rilascio attestazione annuale", group: "attivita-produttive" },
      { value: "pass-disabili", label: 'Richiesta rilascio pass-disabili', group: 'mobilita-trasporti' },
      { value: "accesso-ztl", label: 'Richiesta Accesso ZTL', group: 'mobilita-traporti' },
      { value: "comunicazione-targhe", label: 'Comunicazione targhe', group: 'mobilita-trasporti' },

      { value: "assegno-maternita", label: "Assegno di maternità", group: "educazione-formazione" },
      { value: "osservazioni-pug", label: "Osservazioni al PUG", group: "settore-urbanistica" },
      { value: "bonus-elettrico", label: "Bonus elettrico per disagio fisico", group: "sportello-sociale" },
      { value: "accesso-emporio", label: "Accesso all'Emporio Solidale 'Amalio'", group: "settore-welfare" },
      { value: "accesso-atti", label: "Accesso alle informazioni e ai documenti amministrativi (accesso agli atti)", group: "sportello-cittadino" },
      { value: "comunicazione-targhe", label: "Piano sosta del centro - comunicazione targhe per i residenti nell'area delimitata dalle vie Jussi, Roma, San Lazzaro, Modena", group: "polizia-locale" },

      { value: "Modello_2707", label: "Richiesta di accesso al contributo regionale per la grave disabilità", group: "SuSoc" },
      { value: "Modello_3546", label: "Dichiarazione sostitutiva di atto di notorietà ai fini della richiesta di pubblicazioni di matrimonio", group: "SuAna" },
      { value: "Modello_3590", label: "Richiesta per la concessione dell'assegno di maternità", group: "SuSoc" },



    ],

    tipo_settore: [
      { value: "attivita-produttive", label: "Attività Produttive" },
      { value: "mobilita-trasporti", label: "Mobilità e Trasporti" },

      { value: "sportello-cittadino", label: "Sportello per il cittadino" },
      { value: "polizia-locele", label: "Polizia locale" },
      { value: "settore-welfare", label: "Settore welfare" },
      { value: "educazione-formazione", label: "Educazione formazione" },
      { value: "settore-risorse-umane", label: "Settore risorse umane" },
      { value: "sportello-sociale", label: 'Sportello sociale' }
    ],

    tipo_stato_pagamento: [
      { value: "INSERITO", label: "Inviato in attesa di ricevuta" },
      { value: "AVVISO", label: "Creato avviso di pagamento" },
      { value: "INVIATO", label: "Inviato" },
      { value: "COMPLETATO", label: "Completato" },
      { value: "CONTABILIZZATO", label: "Completato" },
      { value: "NOTIFICATO", label: "Completato e notificato" },
      { value: "RIFIUTATO", label: "Rifiutato" },


    ],

    /*
        varchi: [
          {
            "Key": "CENTRO-STORICO",
            "Name": "Centro Storico",
            "Description": "Centro Storico\n"
          },
          {
            "Key": "TUTTI-I-VARCHI",
            "Name": "Tutti i varchi",
            "Description": "Tutti i varchi\n"
          },
          {
            "Key": "VARCO-CHIODO",
            "Name": "Varco Chiodo",
            "Description": "Varco Chiodo\n"
          },
          {
            "Key": "VARCO-DIAZ",
            "Name": "Varco Diaz",
            "Description": "Varco Diaz\n"
          },
          {
            "Key": "VARCO-FAZIO",
            "Name": "Varco Fazio",
            "Description": "Varco Fazio\n"
          },
          {
            "Key": "VARCO-MANZONI",
            "Name": "Varco Manzoni",
            "Description": "Varco Manzoni\n"
          },
          {
            "Key": "VARCO-MAZZINI",
            "Name": "Varco Mazzini",
            "Description": "Varco Mazzini\n"
          }
        ],


        orari:[
          {
            "Id": 4,
            "Key": "CANTIERI-TRASLOCHI",
            "Name": "CANTIERI-TRASLOCHI",
            "Description": "dalle 07:30 alle 20:00\n",
            "IsAuthorizedByDefault": true
          },
          {
            "Id": 5,
            "Key": "FASCIA-1",
            "Name": "fascia 1",
            "Description": "H24\n",
            "IsAuthorizedByDefault": true
          },
          {
            "Id": 6,
            "Key": "FASCIA-2",
            "Name": "fascia 2",
            "Description": "dalle 07:30 alle 20:00\n",
            "IsAuthorizedByDefault": false
          },
          {
            "Id": 7,
            "Key": "FASCIA-3",
            "Name": "fascia 3",
            "Description": "dalle 20:00 alle 10:00 giorni feriali, H24 giorni festivi\n",
            "IsAuthorizedByDefault": false
          },
          {
            "Id": 8,
            "Key": "FASCIA-4",
            "Name": "fascia 4",
            "Description": "dalle 04:00 alle 10:00 e dalle 14:00 alle 16:00\n",
            "IsAuthorizedByDefault": false
          },
          {
            "Id": 9,
            "Key": "FASCIA-5",
            "Name": "fascia 5",
            "Description": "dalle 18:00 alle 02:00\n",
            "IsAuthorizedByDefault": false
          },
          {
            "Id": 10,
            "Key": "FASCIA-6",
            "Name": "fascia 6",
            "Description": "dalle 04:00 alle 10, dalle 14:00 alle 16:00 e dalle 18:00 alle 02:00\n",
            "IsAuthorizedByDefault": false
          },
          {
            "Id": 1,
            "Key": "H24",
            "Name": "H24",
            "Description": "H24",
            "IsAuthorizedByDefault": true
          },
          {
            "Id": 2,
            "Key": "MATTINO",
            "Name": "mattino",
            "Description": "dalle 06:00 alle 13:00\n",
            "IsAuthorizedByDefault": false
          },
          {
            "Id": 3,
            "Key": "POMERIGGIO",
            "Name": "pomeriggio",
            "Description": "dalle 13:00 alle 20:00\n",
            "IsAuthorizedByDefault": false
          }
        ]
    */

  }


}

